import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';

import CurrencyConverter from '../../CurrencyConverter';
import messages from '../../../locale/messages';
import {
  FEATURED_CAR_FILTERS,
  PRICE_POPOVER_FILTERS,
} from './featuredCarsData';
import FeaturedCarFilterIcon from './featuredCarFilterIcons';
import FeaturedCarsPriceFilter from './FeaturedCarsPriceFilter';

import s from './FeaturedCars.css';

const FILTER_LABELS = {
  all: messages.newLandingAllCarsFilter,
  rentersFavourites: messages.newLandingRentersFavouritesFilter,
  mostPopular: messages.newLandingMostPopularFilter,
  newest: messages.newLandingNewestFilter,
  lowestPrices: messages.newLandingLowestPricesFilter,
  luxury: messages.newLandingLuxuryFilter,
};

const FeaturedCarsFilters = ({
  activeFilter,
  openPricePopover,
  priceRangeDraft,
  appliedPriceRanges,
  isFilterActive,
  onFilterClick,
  onPriceFilterToggle,
  onPriceRangeChange,
  onPriceFilterApply,
  setBtnWrapperRef,
  setPopoverWrapperRef,
}) => {
  const renderPriceFilterLabel = (filterKey) => {
    if (activeFilter === filterKey) {
      const [minPrice, maxPrice] = appliedPriceRanges[filterKey];

      if (filterKey === 'luxury') {
        return (
          <span>
            <CurrencyConverter amount={minPrice} from="USD" />
            <span>{'+'}</span>
          </span>
        );
      }

      return (
        <span>
          <CurrencyConverter amount={minPrice} from="USD" />
          {' - '}
          <CurrencyConverter amount={maxPrice} from="USD" />
        </span>
      );
    }

    return <FormattedMessage {...FILTER_LABELS[filterKey]} />;
  };

  return (
    <div className={s.exploreFilters}>
      {FEATURED_CAR_FILTERS.map((filter) => (
        PRICE_POPOVER_FILTERS.includes(filter.key) ? (
          <FeaturedCarsPriceFilter
            key={filter.key}
            filter={filter}
            isOpen={openPricePopover === filter.key}
            isActive={isFilterActive(filter.key)}
            minPrice={priceRangeDraft[filter.key][0]}
            maxPrice={priceRangeDraft[filter.key][1]}
            buttonLabel={renderPriceFilterLabel(filter.key)}
            onToggle={() => onPriceFilterToggle(filter.key)}
            onRangeChange={(range) => onPriceRangeChange(filter.key, range)}
            onApply={() => onPriceFilterApply(filter.key)}
            setBtnWrapperRef={(node) => setBtnWrapperRef(filter.key, node)}
            setPopoverWrapperRef={(node) => setPopoverWrapperRef(filter.key, node)}
          />
        ) : (
          <button
            type="button"
            key={filter.key}
            className={cx(s.filterBtn, isFilterActive(filter.key) && s.filterBtnActive)}
            onClick={() => onFilterClick(filter.key)}
          >
            <FeaturedCarFilterIcon type={filter.icon} />
            <FormattedMessage {...FILTER_LABELS[filter.key]} />
          </button>
        )
      ))}
    </div>
  );
};

FeaturedCarsFilters.propTypes = {
  activeFilter: PropTypes.string.isRequired,
  openPricePopover: PropTypes.string,
  priceRangeDraft: PropTypes.object.isRequired,
  appliedPriceRanges: PropTypes.object.isRequired,
  isFilterActive: PropTypes.func.isRequired,
  onFilterClick: PropTypes.func.isRequired,
  onPriceFilterToggle: PropTypes.func.isRequired,
  onPriceRangeChange: PropTypes.func.isRequired,
  onPriceFilterApply: PropTypes.func.isRequired,
  setBtnWrapperRef: PropTypes.func.isRequired,
  setPopoverWrapperRef: PropTypes.func.isRequired,
};

FeaturedCarsFilters.defaultProps = {
  openPricePopover: null,
};

export default withStyles(s)(FeaturedCarsFilters);
